import React, { useEffect, useState } from 'react';
import BasicText from '../DebtPaymentComponents/basicText';
import { stepEnum, paymentType } from '../DebtPaymentComponents/debtPaymentEnum';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import EmailCheck from '../DebtPaymentComponents/emailCheck';
import Tooltip from '../../../Shared/Tooltip/Tooltip';
import { Container } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';
import BitPaymentComponent from '../../../Shared/BitPayment/BitPaymentComponent';
import { dwhSelectPaymentOptionDisplay, dwhSelectPaymentOption } from '../reports/dwhReports';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import { isMobile } from 'react-device-detect';


import '../debtPayment.scss';

const DebtPaymentSelectPaymentOption = (props) => {
  const [mount, setMount] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const bitTooltipText = `התשלום באמצעות bit מבוצע באתר אינטרנט או בישומון bit, בהתאם לתנאי השימוש ולמדיניות הפרטיות של בנק הפועלים בע"מ ומותנה בקיומו של משתמש רשום ב-bit. בבחירת אפשרות תשלום זו ניתנת הסכמתך להעברת פרטיך (מספר טלפון וסכום לתשלום) לבנק הפועלים.`;
  const selectedAmount = `סכום לתשלום: ${props.privateAmount}`;
  const debtAmount = `סה"כ יתרה: ${props.savedData.amount}`;
  const source = props.isJetConnection ? 'JET' : 'WEBSITE';
  const customerName = props.savedCustomerData.name;
  const ban = props.selectedBan;
  const idNumber = props.idNumber;
  const subscriber = props.phoneNumber;

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.currentStep === stepEnum.SELECTPAYMENTTYPE) {
          setMount(true);
          if (!props.bitReturnEvent) {
            dwhSelectPaymentOptionDisplay({ debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber });
            gtag4({
              event: 'DebtPayment_Step1_PaymentPage',
              step: '1',
              action: 'PaymentPage',
            });
          }
        } else {
          setMount(false);
        }
      }
    },
    [props.currentStep],
  );

  const radioBtns = [
    { id: 'bit', label: 'לתשלום באמצעות ', value: 'bit' },
    {
      id: 'creditcard',
      label: 'לתשלום באמצעות כרטיס אשראי',
      value: 'creditcard',
    },
  ];
  const getOutstandingBalance = () => {
    let res = parseFloat(props.savedData.amount) - parseFloat(props.privateAmount);
    return res?.toFixed(2);
  };
  const onRadioBtnChange = (e) => {
    let value = e.currentTarget.value;
    props.setSelectedPaymentType(value);
  };

  function checkEmail() {
    return (props.isEmailRequested && props.isEmailRequestedError === '' && props.email !== '') || !props.isEmailRequested;
  }

  const setSelectedForUpdate = () => {
    if (checkEmail()) {
      setEmailError(false);
      let messageText;
      if (props.selectedPaymentType == paymentType.BIT) {
        gtag4({
          event: 'DebtPayment_Step2_BitButton',
          step: '2',
          button: 'המשך לתשלום',
          action: 'BitButton',
        });
        messageText = 'BIT Payment method Button Clicked';
        dwhSelectPaymentOption({ messageText, debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber });
        props.getPaymentStatusesForBan(ban)

      } else {
        gtag4({
          event: 'DebtPayment_Step2_CcButton',
          step: '2',
          button: 'המשך לתשלום',
          action: 'CcButton',
        });
        messageText = 'Credit Card Payment method Button Clicked';
        dwhSelectPaymentOption({ messageText, debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber });
        props.handleCurrentStep(stepEnum.CREDITCARD);
      }
    } else if (props.isEmailRequestedError === '') {
      setEmailError(true);
    }
  };

  return (
    <CSSTransition key={2} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step '>
        <div className='select-payment-type'>
          <div>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </div>
          <div>
            <BasicText text='פרטי תשלום' bold classname='payment-option-title' />
          </div>
          <div className='background payment-info'>
            <div className='total'>סה״כ לתשלום: ₪{props.privateAmount}</div>
            <div>
              {props.savedCustomerData.idNumber} {props.savedCustomerData.name}
            </div>
            <div>{props.savedData.productDescriptions}</div>
            {parseFloat(props.savedData.amount) > parseFloat(props.privateAmount) && <div>יתרת חוב: ₪{getOutstandingBalance()} </div>}
          </div>
          {!isMobile && <div className='select-payment-type debt-payment-border'></div>}
          <div className='select-payment-type-radio'>
            <div className='select-payment-type-radio-title'>בחר אמצעי תשלום מועדף</div>
            {radioBtns.map((rb) => {
              return (
                <div className={`radio-btn-item ${props.selectedPaymentType == rb.value ? 'checked' : ''} ${rb.value}`} key={rb.id}>
                  <RadioInput
                    checked={props.selectedPaymentType == rb.value}
                    id={rb.id}
                    name='paymentoption'
                    value={rb.value}
                    label={rb.label}
                    onChange={onRadioBtnChange}
                  />
                </div>
              );
            })}
          </div>
          <div className='background invoice-by-email'>
            <EmailCheck
              handleCheckBox={props.setEmailRequested}
              checked={props.isEmailRequested}
              emailError={emailError}
              isPrivate={true}
            />
          </div>
          <div className='bit-tooltip'>
            <div className='bit-tooltip-title' id={'bitTooltip'}>
              למידע נוסף אודות התשלום באמצעות bit
            </div>
            <Tooltip title={''} text={bitTooltipText} target={`bitTooltip`} placement={'top'} cellcomdefault={true} />
          </div>
          <div>
            <BtnSubmit text='המשך לתשלום' onclick={() => (props.selectedPaymentType ? setSelectedForUpdate() : null)} />
          </div>
        </div>
        {(props.bitIsReady || props.bitReturnEvent) && (
          <BitPaymentComponent
            bitReturnEvent={props.bitReturnEvent}
            actionOnPaymentPending={props.validateStatusOnPending}
            actionOnPaymentCompleted={props.validateStatus}
            ban={props.selectedBan}
            paymentAmount={props.privateAmount}
          />
        )}
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentSelectPaymentOption;
